import React from 'react';

const Loading = ({isSymbol}) => {
  isSymbol = isSymbol || false;
  
  return(
    <div style={{display: 'flex', justifyContent: 'center'}}><p className="text-info">Loading...</p></div>
  )
}

export default Loading;


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/Loading.jsx